/*** IMPORTS FROM imports-loader ***/
(function() {
var app = window.app||{};
var define = false;
var exports = false;
var module = undefined;

var app = app || {};

(function () {
  'use strict';

  /**
   * Интервалы времени доставки для выбора на странице оформления заказа.
   */
  app.DeliveryIntervalsView = app.DeliveryPopupSelectView.extend({

    type: 'interval',

    el: '.delivery-choice-time',

    run: function (options) {
      if (options && options.formModel) {
        this.formModel = options.formModel;
      }

      app.DeliveryPopupSelectView.prototype.run.apply(this, arguments);
    },

    render: function () {
      if (this.model) {
        var template = app.helpers.TemplateHelper.getTemplate('#delivery-date-interval-template');
        this.$('.popup ul').html(template({
          model: this.model.toJSON(),
          deliveryTypeId: this.formModel.get('deliveryTypeId'),
          DELIVERY_TYPE_ID_SIMALAND: String(app.DELIVERY_TYPES.simaland),
        }));
        app.DeliveryPopupSelectView.prototype.render.apply(this, arguments);
        this.$el.removeClass('disabled').removeClass('not_display');
      } else {
        this.$el.addClass('disabled');
        if (this.popup) {
          this.$('.popup').addClass('not_display');
        }
      }
    },

    setModel: function (model) {
      this.model = model;
      this.render();
    },

    hide: function () {
      this.$el.addClass('disabled').addClass('not_display');
    }
  });

})();

}.call(window));